import { useProduct } from 'modules/products/hooks/use-products'
import { useRouter } from 'next/router'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { ChevronDownIcon } from '@systemeio/ui/icons'

function ProductBreadcrumbs() {
  const router = useRouter()
  const { productId } = router.query
  const { data: product } = useProduct(Number(productId))
  const { t } = useLocoTranslation()

  return (
    <>
      {product && (
        <div className="text-text-primary mb-2 flex items-center gap-2 px-6 text-xl font-semibold">
          <div className="cursor-pointer">
            <LinkWithoutPrefetch href="/products">
              {t('dashboard.products.list.title')}
            </LinkWithoutPrefetch>
          </div>
          <ChevronDownIcon className="rotate-[-90deg]" width="25px" height="8px" />
          <div className="cursor-pointer">{product.name}</div>
        </div>
      )}
    </>
  )
}
export default ProductBreadcrumbs
